import { render, staticRenderFns } from "./IcoHeart.vue?vue&type=template&id=24cbaa21"
import script from "./IcoHeart.vue?vue&type=script&lang=js"
export * from "./IcoHeart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports